/* Centralized framer-motion variants for the portfolio */

/* ===== Container variants (stagger children) ===== */
export const staggerContainer = (staggerDelay = 0.12, startDelay = 0.2) => ({
    hidden: {},
    visible: {
        transition: {
            staggerChildren: staggerDelay,
            delayChildren: startDelay,
        },
    },
});

/* ===== Individual element variants ===== */
export const fadeUp = {
    hidden: { opacity: 0, y: 30, filter: 'blur(4px)' },
    visible: {
        opacity: 1,
        y: 0,
        filter: 'blur(0px)',
        transition: {
            type: 'spring',
            stiffness: 100,
            damping: 20,
        },
    },
};

export const fadeIn = {
    hidden: { opacity: 0, filter: 'blur(4px)' },
    visible: {
        opacity: 1,
        filter: 'blur(0px)',
        transition: {
            type: 'spring',
            stiffness: 80,
            damping: 20,
        },
    },
};

export const scaleUp = {
    hidden: { opacity: 0, scale: 0.92, filter: 'blur(4px)' },
    visible: {
        opacity: 1,
        scale: 1,
        filter: 'blur(0px)',
        transition: {
            type: 'spring',
            stiffness: 100,
            damping: 20,
        },
    },
};

export const slideLeft = {
    hidden: { opacity: 0, x: 60, filter: 'blur(4px)' },
    visible: {
        opacity: 1,
        x: 0,
        filter: 'blur(0px)',
        transition: {
            type: 'spring',
            stiffness: 100,
            damping: 20,
        },
    },
};

export const slideRight = {
    hidden: { opacity: 0, x: -60, filter: 'blur(4px)' },
    visible: {
        opacity: 1,
        x: 0,
        filter: 'blur(0px)',
        transition: {
            type: 'spring',
            stiffness: 100,
            damping: 20,
        },
    },
};

/* ===== Card hover ===== */
export const cardHover = {
    rest: { y: 0, scale: 1 },
    hover: {
        y: -8,
        scale: 1.01,
        transition: {
            type: 'spring',
            stiffness: 300,
            damping: 20,
        },
    },
};

/* ===== Button hover ===== */
export const buttonHover = {
    rest: { scale: 1 },
    hover: {
        scale: 1.04,
        transition: {
            type: 'spring',
            stiffness: 400,
            damping: 15,
        },
    },
    tap: { scale: 0.97 },
};

/* ===== Page transitions ===== */
export const pageVariants = {
    initial: {
        opacity: 0,
        y: 20,
        filter: 'blur(6px)',
        scale: 0.99,
    },
    animate: {
        opacity: 1,
        y: 0,
        filter: 'blur(0px)',
        scale: 1,
    },
    exit: {
        opacity: 0,
        y: -10,
        filter: 'blur(4px)',
        scale: 0.99,
    },
};

export const pageTransitionConfig = {
    type: 'spring',
    stiffness: 80,
    damping: 20,
};

export const pageExitConfig = {
    duration: 0.3,
    ease: [0.16, 1, 0.3, 1],
};

/* ===== Floating / decorative ===== */
export const floatingBlob = (duration = 12) => ({
    animate: {
        y: [0, -20, 0, 15, 0],
        x: [0, 15, 0, -10, 0],
        scale: [1, 1.05, 1, 0.97, 1],
        transition: {
            duration,
            repeat: Infinity,
            ease: 'easeInOut',
        },
    },
});

/* ===== Mesh gradient morph ===== */
export const meshGradientMotion = {
    animate: {
        backgroundPosition: ['0% 0%', '100% 50%', '50% 100%', '0% 0%'],
        transition: {
            duration: 20,
            repeat: Infinity,
            ease: 'easeInOut',
        },
    },
};
